import {
  PREACRIS_SET_LOADING,
  PreacrisState,
  PreacrisTypes,
  GET_PREACRIS_STATES_SUCCESS,
  RESET_DRIVERS_DATA,
  GET_PREACRIS_DRIVERS_SUCCESS,
  RESET_XDETAILS_DATA,
  GET_PREACRIS_XDETAILS_SUCCESS,
} from './Preacris.types';

const defaultState = {
  loading: false,
  usStates: null,
  driversData: null,
  xdetailsData: null,
};

export function preacrisReducer(
  state = defaultState,
  action: PreacrisTypes,
): PreacrisState {
  console.log(action.type);
  switch (action.type) {
    case GET_PREACRIS_STATES_SUCCESS: {
      return {
        ...state,
        usStates: action.usStates,
        loading: false,
      };
    }
    case PREACRIS_SET_LOADING: {
      return {
        ...state,
        loading: action.loading,
      };
    }
    case GET_PREACRIS_DRIVERS_SUCCESS: {
      return {
        ...state,
        driversData: action.driversData,
      };
    }
    case RESET_DRIVERS_DATA: {
      return {
        ...state,
        driversData: null,
      };
    }
    case GET_PREACRIS_XDETAILS_SUCCESS: {
      return {
        ...state,
        xdetailsData: action.xdetailsData,
      };
    }
    case RESET_XDETAILS_DATA: {
      return {
        ...state,
        xdetailsData: null,
      };
    }
    default:
      return state;
  }
}
